module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Outages","short_name":"Outages","start_url":"/","display":"standalone","icon":"src/images/CEBOutages4.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"89268614008ea2438f4427f98c5da07d"},
    }]
